import {
    FIELD_TYPE_CHECKBOXES,
    FIELD_TYPE_RADIO,
    FIELD_TYPE_FILE,
    FIELD_TYPE_DATE,
} from "@/domains/profile/constants/custom-types";
import { SIZE_NAMES } from "@/domains/profile/constants/field-sizes";
import {
    FIELD_TYPE_REGISTRATION_ADDRESS,
    FIELD_TYPE_ADDITIONAL_EDUCATION,
    FIELD_TYPE_BIRTHDAY,
    FIELD_TYPE_CITIZENSHIP,
    FIELD_TYPE_COMMENT,
    FIELD_TYPE_COVID,
    FIELD_TYPE_DESIRED_POSITION,
    FIELD_TYPE_FRIENDS_IN_COMPANY,
    FIELD_TYPE_FULL_NAME,
    FIELD_TYPE_GENDER,
    FIELD_TYPE_METRO,
    FIELD_TYPE_RESIDENTIAL_ADDRESS,
    FIELD_TYPE_SOCIALS,
    FIELD_TYPE_TRAVELING_WORK,
    FIELD_TYPE_VACANCY_SOURCE,
    FIELD_TYPE_WAY_TO_WORK,
    FIELD_TYPE_PHONE,
    FIELD_TYPE_EMAIL,
    FIELD_TYPE_PHOTO,
} from "@/domains/profile/constants/system-types";

const CUSTOM_FIELDS_SIZE = {
    [FIELD_TYPE_FILE]: "full",
    [FIELD_TYPE_CHECKBOXES]: "full",
    [FIELD_TYPE_RADIO]: "full",
    [FIELD_TYPE_DATE]: "sm",
};

const SYSTEM_FIELDS_SIZE = {
    [FIELD_TYPE_REGISTRATION_ADDRESS]: "xl",
    [FIELD_TYPE_RESIDENTIAL_ADDRESS]: "xl",

    [FIELD_TYPE_ADDITIONAL_EDUCATION]: "xl",
    [FIELD_TYPE_COMMENT]: "xl",
    [FIELD_TYPE_FULL_NAME]: "xl",
    [FIELD_TYPE_FRIENDS_IN_COMPANY]: "xl",

    [FIELD_TYPE_COVID]: "lg",
    [FIELD_TYPE_TRAVELING_WORK]: "lg",
    [FIELD_TYPE_DESIRED_POSITION]: "lg",

    [FIELD_TYPE_CITIZENSHIP]: "md",
    [FIELD_TYPE_METRO]: "md",
    [FIELD_TYPE_VACANCY_SOURCE]: "md",
    [FIELD_TYPE_WAY_TO_WORK]: "md",
    [FIELD_TYPE_PHONE]: "md",
    [FIELD_TYPE_EMAIL]: "md",

    [FIELD_TYPE_BIRTHDAY]: "sm",
    [FIELD_TYPE_PHOTO]: "sm",

    [FIELD_TYPE_GENDER]: "md",

    [FIELD_TYPE_SOCIALS]: "xl",
};

export function getFieldSize(field) {
    const { isSystem, size, fieldType } = field;

    if (!isSystem) {
        return CUSTOM_FIELDS_SIZE[fieldType] || SIZE_NAMES[size];
    }

    return SYSTEM_FIELDS_SIZE[fieldType] || "full";
}
